// components/Features.js
import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: <i className="fas fa-bolt"></i>,
      title: "Lightning Fast",
      description: "Process transactions in seconds with our optimized system designed for speed and reliability."
    },
    {
      icon: <i className="fas fa-chart-line"></i>,
      title: "Real-time Analytics",
      description: "Get instant insights into your business performance with beautiful, easy-to-understand dashboards."
    },
    {
      icon: <i className="fas fa-mobile-alt"></i>,
      title: "Mobile Ready",
      description: "Access your POS from any device, anywhere. Manage your business on the go with our mobile app."
    },
    {
      icon: <i className="fas fa-lock"></i>,
      title: "Secure Payments",
      description: "PCI compliant with end-to-end encryption. Your customers' payment data is always safe with us."
    },
    {
      icon: <i className="fas fa-boxes"></i>,
      title: "Inventory Management",
      description: "Track stock levels, set automatic reordering points, and manage suppliers all in one place."
    },
    {
      icon: <i className="fas fa-users"></i>,
      title: "Customer CRM",
      description: "Manage customer relationships, track purchase history, and create loyalty programs to boost retention."
    }
  ];

  return (
    <section id="features" className="section">
      <div className="container">
        <h2 className="section-title">Powerful Features</h2>
        <p className="section-subtitle">Everything you need to run your business efficiently and boost your sales</p>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;